import { render } from "./Lens.vue?vue&type=template&id=2fd6c080"
import script from "./Lens.vue?vue&type=script&lang=js"
export * from "./Lens.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Lens.vue"]])

export default __exports__